/**
 * @author Sasanka Weerakoon
 * @version 0.0.1
 * @since 21/4/2025
 */
import React from "react";
import labelsEN from "../../../../locales/en/translation.json";
import Box from "@mui/material/Box";
import { Tab, Tabs } from "react-bootstrap";
import UserReport from "./components/UserReport";
import OrganizationReport from "./components/OrganizationReport";
import GroupReport from "./components/GroupReport";
import "../reports/styles/reports.style.scss";
import TerminalReport from "./components/TerminalReport";
import ApplicationReport from "./components/ApplicationReport";

const Reports = () => {
  return (
    <div className="reports-page">
      <Box sx={{ width: "100%" }}>
        <h1 className="mb-4">{labelsEN.app_report_page_title}</h1>
        <Tabs defaultActiveKey="userReports" id="report-tabs" className="report-tabs mb-4" justify>
          <Tab eventKey="userReports" title={"Users"}>
            <UserReport />
          </Tab>
          <Tab eventKey="orgnaziationReports" title={"Organizations"}>
            <OrganizationReport />
          </Tab>
          <Tab eventKey="groupReports" title={"Groups"}>
            <GroupReport />
          </Tab>
          <Tab eventKey="terminalReports" title={"Terminals"}>
            <TerminalReport />
          </Tab>
          <Tab eventKey="applicationReports" title={"Applications"}>
            <ApplicationReport />
          </Tab>
        </Tabs>
      </Box>
    </div>
  );
};

export default Reports;
